import React, { ReactElement } from 'react';
import { Grid } from 'semantic-ui-react';
import get from 'lodash.get';
import {
    SprayEventOperations,
    SprayEventOperatorsIndex
} from 'services/sprayEvents/types';

import FieldValues from 'components/FieldValues';
import { CalibrationId } from 'services/equipmentSets/types';
import Range from './Range';
import Details from './Details';

import Status from './Status';
import { OperatorFieldNames } from '../../../MultipleOperatorsTab/constants';

export type Props = { name?: string };

export type State = {
    selectedCalibrationId?: CalibrationId;
};

export class CalibrationsComponent extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            selectedCalibrationId: undefined
        };

        this.setSelectedCalibrationId =
            this.setSelectedCalibrationId.bind(this);
    }

    setSelectedCalibrationId = (selectedCalibrationId: CalibrationId): void => {
        this.setState({ selectedCalibrationId });
    };

    getSprayEquipmentSetId = (
        sprayEventOperations: SprayEventOperations
    ): number | undefined => {
        const { name = '' } = this.props;

        switch (name) {
            case OperatorFieldNames.OUTSIDE: {
                const outSideRowOperator = get(
                    sprayEventOperations,
                    SprayEventOperatorsIndex.OUTSIDE,
                    undefined
                );

                return (
                    outSideRowOperator && outSideRowOperator.sprayEquipmentSetId
                );
            }
            case OperatorFieldNames.DOUBLE: {
                const doubleRowOperator = get(
                    sprayEventOperations,
                    SprayEventOperatorsIndex.DOUBLE,
                    undefined
                );

                return (
                    doubleRowOperator && doubleRowOperator.sprayEquipmentSetId
                );
            }
            default: {
                const standardOperator = get(
                    sprayEventOperations,
                    SprayEventOperatorsIndex.STANDARD,
                    undefined
                );

                return standardOperator && standardOperator.sprayEquipmentSetId;
            }
        }
    };

    render(): ReactElement {
        const { selectedCalibrationId } = this.state;

        return (
            <Grid className="calibration">
                <FieldValues
                    fieldNames={[
                        'sprayEntityIds',
                        'sprayApplicationRate',
                        'sprayEventOperations'
                    ]}
                >
                    {({
                        sprayEntityIds,
                        sprayApplicationRate,
                        sprayEventOperations
                    }): React.ReactElement => {
                        // Converts string to number, as it should be a number when used in selectors
                        const applicationRate = Number(sprayApplicationRate);

                        return (
                            <React.Fragment>
                                <Grid.Row>
                                    <Grid.Column>
                                        <p className="label-title">
                                            Calibrations
                                        </p>
                                        <p className="label-subtitle">
                                            Based on row width
                                        </p>
                                    </Grid.Column>
                                </Grid.Row>
                                <Range
                                    equipmentSetId={
                                        this.getSprayEquipmentSetId(
                                            sprayEventOperations
                                        ) as number
                                    }
                                    entityIds={sprayEntityIds}
                                    setSelectedCalibrationId={
                                        this.setSelectedCalibrationId
                                    }
                                    selectedCalibrationId={
                                        selectedCalibrationId
                                    }
                                    applicationRate={applicationRate}
                                />
                                <Details
                                    calibrationId={selectedCalibrationId}
                                    equipmentSetId={this.getSprayEquipmentSetId(
                                        sprayEventOperations
                                    )}
                                    entityIds={sprayEntityIds}
                                    applicationRate={applicationRate}
                                />
                                <Status
                                    equipmentSetId={this.getSprayEquipmentSetId(
                                        sprayEventOperations
                                    )}
                                    entityIds={sprayEntityIds}
                                    applicationRate={applicationRate}
                                />
                            </React.Fragment>
                        );
                    }}
                </FieldValues>
            </Grid>
        );
    }
}

export default CalibrationsComponent;
